module.exports = __webpack_public_path__ + "static/img/eec-group2-1.014f0a2d.png";